import grains from "../Assets/Products/Grains-menu.jpg";
import rice from "../Assets/Products/Rice-menu.jpg";
import pulses from "../Assets/Products/Pules-menu.jpg";
import spicesandNuts from "../Assets/Products/SpicesAndNuts-menu.jpg";
import flourandMasalas from "../Assets/Products/FlourAndMasalamenu.jpg";
import oilingredients from "../Assets/Products/Oil&Ingridents.jpg";

import limited1 from "../Assets/Products/Limited_11.png";
import limited2 from "../Assets/Products/Limited_22.png";
import limited3 from "../Assets/Products/Limited_33.jpeg";
import limited4 from "../Assets/Products/Limited_44.png";
import limited5 from "../Assets/Products/Limited_55.jpeg";

import Product_1 from "../Assets/Products/Product_1.jpeg";
import Product_2 from "../Assets/Products/Product_2.png";
import Product_3 from "../Assets/Products/Product_3.png";
import Product_4 from "../Assets/Products/Product_4.png";
import Product_5 from "../Assets/Products/Product_5.png";
import Product_6 from "../Assets/Products/Product_6.png";
import Product_7 from "../Assets/Products/Product_7.png";
import Product_8 from "../Assets/Products/Product_9.jpg";
import AmericaFlag from '../Assets/Flag/AmericaFlag.jpg'
import IndiaFlag from '../Assets/Flag/IndiaFlag.jpg'
import ReadyForCook from '../Assets/Products/Ready_For_Cook_Menu.jpg'
import DiaryProducts from '../Assets/Products/fresh-dairy-products.jpg'
import Tea_and_coffee from '../Assets/Products/Tea&coffeeView.jpg'
import HealthDrinks from '../Assets/Products/HealthDrinksview.jpg'
import Biscuit from '../Assets/Products/Biscuitview.jpg'
import snacks from '../Assets/Products/Snacksview.jpg'
import otherIngredients from '../Assets/Products/other_ingredients_menu.jpg'
import oralcare from '../Assets/Products/OralCareview.jpg'
import bodycare from '../Assets/Products/BodyCareview.jpg'
import haircare from '../Assets/Products/HairCareview.jpg'
import facecare from '../Assets/Products/FaceCareView.jpg'
import babycare from '../Assets/Products/BabyCareProducts.jpg'
import hairRemoval from '../Assets/Products/ShavingHairRemoval.jpg'
import feminineHygiene from '../Assets/Products/FemineHygiene.jpg'
import laundryDetergent from '../Assets/Products/LaundryDetergentimage.jpg'
import utensilscleaning from '../Assets/Products/Utensilscleaningwasher.jpg'
import cleaningTool from '../Assets/Products/CleaningToolsview.jpg'
import poojaDevotional from '../Assets/Products/poojadevotional.jpg'
import stationary from '../Assets/Products/Stationaryimage.jpg'
import miscellaneous from '../Assets/Products/Miscellaneousimage.jpg' 
import insertRepellent from '../Assets/Products/InsertRepellentsview.jpg'
import householdCleaning from '../Assets/Products/Householdcleaning.jpg'
import { StoreMenuData, StoreProduct } from "../Interface/Product.interface";


export const sizes: string[] = ["L", "XL", "XXL", "Panty Liner"];

export const sizesDetails: string[] = [
  "280mm (12 Pads)",
  "320mm (10 Pads)",
  "410mm (5 Pads)",
  "180mm (30 Pieces)",
];

export const storeMenuData: StoreMenuData = {
  grains,
  rice,
  pulses,
  spicesandNuts,
  flourandMasalas,
  oilingredients,
  AmericaFlag,
  IndiaFlag,
  ReadyForCook,
  DiaryProducts,
  otherIngredients,
  HealthDrinks,
  Biscuit,
  snacks,
  Tea_and_coffee,
  oralcare,
  bodycare,
  haircare,
  facecare,
  babycare,
  hairRemoval,
  feminineHygiene,
  laundryDetergent,
  utensilscleaning,
  cleaningTool,
  poojaDevotional,
  stationary,
  miscellaneous,
  insertRepellent,
  householdCleaning
};

export const latestProduct: StoreProduct[] = [
  {
    id: 1,
    productID: "1",
    frontImg: Product_1,
    productName: "Health Mix Ingredients Raw",
    productPrice: 29,
    productReviews: "8k+ reviews",
  },
  {
    id: 2,
    productID: "2",
    frontImg: Product_2,
    productName: "FEMI9 SANITARY NAPKIN",
    productPrice: 62,
    productReviews: "2k+ reviews",
  },
  {
    id: 3,
    productID: "3",
    frontImg: Product_3,
    productName: "KOPIKO Cappuccino Coffee Candy",
    productPrice: 60,
    productReviews: "7k+ reviews",
  },
  {
    id: 4,
    productID: "4",
    frontImg: Product_4,
    productName: "Parle 2 in 1 Eclairs",
    productPrice: 17,
    productReviews: "5k+ reviews",
  },
  {
    id: 5,
    productID: "5",
    frontImg: Product_5,
    productName: "PARLE Kaccha Mango Bite Raw Mango Flavoured Candy",
    productPrice: 100,
    productReviews: "9k+ reviews",
  },
  {
    id: 6,
    productID: "6",
    frontImg: Product_6,
    productName: "Parle Melody Chocolaty",
    productPrice: 69,
    productReviews: "1k+ reviews",
  },
  {
    id: 7,
    productID: "7",
    frontImg: Product_7,
    productName: "Aachi Pickle 200g (Buy 1 get 1 free)",
    productPrice: 99,
    productReviews: "3k+ reviews",
  },
  {
    id: 8,
    productID: "8",
    frontImg: Product_8,
    productName: "Freshnol Phenyl",
    productPrice: 37,
    productReviews: "4k+ reviews",
  },
];

const StoreData: StoreProduct[] = [
  {
    id: 1,
    productID: "1",
    frontImg: Product_1,
    productName: "Health Mix Ingredients Raw",
    productPrice: 29,
    productReviews: "8k+ reviews",
    productDiscount: 56,
  },
  {
    id: 2,
    productID: "2",
    frontImg: Product_2,
    productName: "FEMI9 SANITARY NAPKIN",
    productPrice: 62,
    productReviews: "2k+ reviews",
    productDiscount: 70,
  },
  {
    id: 3,
    productID: "3",
    frontImg: Product_3,
    productName: "KOPIKO Cappuccino Coffee Candy",
    productPrice: 60,
    productReviews: "7k+ reviews",
    productDiscount: 90,
  },
  {
    id: 4,
    productID: "4",
    frontImg: Product_4,
    productName: "Parle 2 in 1 Eclairs",
    productPrice: 17,
    productReviews: "5k+ reviews",
    productDiscount: 89,
  },
  {
    id: 5,
    productID: "5",
    frontImg: Product_5,
    productName: "PARLE Kaccha Mango Bite Raw Mango Flavoured Candy",
    productPrice: 100,
    productReviews: "9k+ reviews",
    productDiscount: 120,
  },
  {
    id: 6,
    productID: "6",
    frontImg: Product_6,
    productName: "Parle Melody Chocolaty",
    productPrice: 69,
    productReviews: "1k+ reviews",
    productDiscount: 90,
  },
  {
    id: 7,
    productID: "7",
    frontImg: Product_7,
    productName: "Aachi Pickle 200g (Buy 1 get 1 free)",
    productPrice: 99,
    productReviews: "3k+ reviews",
    productDiscount: 120,
  },
  {
    id: 8,
    productID: "8",
    frontImg: Product_8,
    productName: "Freshnol Phenyl",
    productPrice: 37,
    productReviews: "4k+ reviews",
  },
  {
    id: 9,
    productID: "9",
    frontImg: limited1,
    productName: "Mysore Sandal Freshnol Phenyl (buy1 get 1 Free)",
    productPrice: 29,
    productReviews: "8k+ reviews",
    productDiscount: 78,
  },
  {
    id: 10,
    productID: "10",
    frontImg: limited2,
    productName: "Hanneman Pouf",
    productPrice: 92,
    productReviews: "5k+ reviews",
    productDiscount: 180,
  },
  {
    id: 11,
    productID: "11",
    frontImg: limited3,
    productName: "Cushion Futon Slipcover",
    productPrice: 25,
    productReviews: "1k+ reviews",
    productDiscount: 190,
  },
  {
    id: 12,
    productID: "12",
    frontImg: limited4,
    productName: "Hub Accent Mirror",
    productPrice: 27,
    productReviews: "7k+ reviews",
    productDiscount: 70,
  },
  {
    id: 13,
    productID: "13",
    frontImg: limited5,
    productName: "Bold Male Black Analog",
    productPrice: 39,
    productReviews: "71+ reviews",
    productDiscount: 89,
  },
];

export default StoreData;
